import Vue from "vue";
const widgetSound = "/webchat/sounds/Message+ringtone+widget.mp3";
export default Vue.extend({
    data(){
        return{
            toggleWindowBubble: false,
            soundFailed: false,
            tabVisible: true,
            hidden: null,
            visibilityChangeEvent: null,
        };
    },
    computed:{
        checkWidgetOpenState(){
            return this.toggleWindowBubble;
        }
    },
    mounted() {
        this.listenToTabViability();
    },
    methods:{
        playSound(){
            this.soundFailed = false;
            let sound = document.getElementById("player") as HTMLAudioElement;
            sound.src = this.soundNotificationSource();
            sound.autoplay = true;
            sound.play().then(() => {
                this.soundFailed = false;
                return null;
            }).catch(err => {
                this.soundFailed = true;
                console.log("ERROR:", err);
            });

    
        },
        soundNotificationSource(){
            //play different sound if chat widget is open or not
            // if(this.toggleWindowBubble && this.tabVisible){
            //     return widgetOpenSound;
            // }else if(!this.tabVisible || !this.toggleWindowBubble){
            //     return widgetClosedSound;
            // }
            return widgetSound; // Unify notification sound for both cases
        },
        listenToTabViability(){
            this.checkSupportedEvent();
            document.addEventListener(this.visibilityChangeEvent, this.handleVisibilityChange, false);
        },
        checkSupportedEvent(){
            let doc:any = document;
            //some browsers support different event name for tab visibility so
            //before start the listener we define the exact event name
            if (typeof doc.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
                this.hidden = "hidden";
                this.visibilityChangeEvent = "visibilitychange";
            } else if (typeof doc.msHidden !== "undefined") {
                this.hidden = "msHidden";
                this.visibilityChangeEvent = "msvisibilitychange";
            } else if (typeof doc.webkitHidden !== "undefined") {
                this.hidden = "webkitHidden";
                this.visibilityChangeEvent = "webkitvisibilitychange";
            }
        },
        handleVisibilityChange() {
            let doc:any = document;
            if (doc[this.hidden]) {
                this.tabVisible = false;
            } else {
                this.tabVisible = true;
            }
        }

    },
    beforeDestroy() {
        document.removeEventListener(this.visibilityChangeEvent, this.handleVisibilityChange, false);
    },
});
